import { useEffect, useRef } from "react";

const useRegisterLoanSection = (registerSectionHandler, handlers) => {
	const handlersRef = useRef(handlers);
	handlersRef.current = handlers;

	useEffect(() => {
		if (!registerSectionHandler) {
			return undefined;
		}

		registerSectionHandler({
			validate: (...args) => handlersRef.current?.validate?.(...args),
			save: (...args) => handlersRef.current?.save?.(...args),
			highlightErrors: (...args) =>
				handlersRef.current?.highlightErrors?.(...args),
		});

		return undefined;
	}, [registerSectionHandler]);
};

export default useRegisterLoanSection;
